import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

import { FlexColumn } from "components/FlexColumn";
import AnswerContextProvider, { useAnswerContext } from "contexts/answerContext";
import { errorPropType, fieldPropType, tenantPropType } from "utils/sharedPropTypes";

import styles from "./ComponentField.scss";
import FormField from "./Field";

const ComponentField = ({ field, value, onChange, onSave, error, tenant }) => {
  const answerContext = useAnswerContext();
  const { children } = field;

  const onChildChange =
    ({ component_key }) =>
    (_field, childValue) => {
      onChange(R.compose(R.assoc(component_key, childValue), R.defaultTo({}))(value));
    };

  if (!children) {
    return null;
  }

  return (
    <FlexColumn className={styles.fieldGroup} data-component-field>
      {children.map((childField) => (
        <AnswerContextProvider
          key={childField.id}
          value={R.compose(
            R.assoc("onChange", onChildChange(childField)),
            R.assoc("onSave", onSave),
          )(answerContext)}
        >
          <FormField
            error={R.prop(R.prop("id", childField), error)}
            field={childField}
            onBlur={R.T}
            onFocus={R.T}
            tenant={tenant}
            value={R.prop(R.prop("component_key", childField), value)}
          />
        </AnswerContextProvider>
      ))}
    </FlexColumn>
  );
};

ComponentField.propTypes = {
  error: errorPropType,
  field: PropTypes.shape({ children: PropTypes.arrayOf(fieldPropType) }),
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  tenant: tenantPropType.isRequired,
  value: PropTypes.object,
};

export const Disabled = ({ field, value }) => {
  if (!field.children) return null;
  const children = R.map(
    (child) => (
      <FormField
        key={child.key}
        field={child}
        value={R.prop(child.component_key, value)}
        behaviorType="disabled"
        hideHelp
        hideRequired
      />
    ),
    field.children,
  );
  return <div className={styles.fieldGroup}>{children}</div>;
};
Disabled.propTypes = {
  field: PropTypes.shape({
    children: PropTypes.arrayOf(fieldPropType),
  }),
  value: PropTypes.object,
};

export const Issued = ({ field, value }) => {
  if (!field.children) return null;
  return R.map(
    (child) => (
      <FormField
        key={child.key}
        field={child}
        value={R.prop(child.component_key, value)}
        behaviorType="issued"
        hideHelp
        hideRequired
      />
    ),
    field.children,
  );
};

export default ComponentField;
